import * as React from 'react';
import { getIn } from 'formik';

import { WizardSubmitButton } from 'buyside/components/presentation/Form/Wizard/Wizard';
import Selectable from 'buyside/components/presentation/Selectable/selectable';
import PageHeader from '../../Helpers/pageHeader';
import PageFooter from '../../Helpers/PageFooter';

import { ApplicantTypes, AllFormikProps } from 'interfaces/userApplication/userApplication';
import { SelectableTypes } from 'interfaces/selectable/selectable';
import RecaptchaFailed from '../../Helpers/RecaptchaFailed';

import styles from '../pageStyles.scss';

type PickedFormikProps = Pick<AllFormikProps, 'errors' | 'touched' | 'values'>;

interface ATPProps extends PickedFormikProps {
  handleSelect: (applicantType: ApplicantTypes) => void;
  isLoading: boolean;
  isRobot: boolean;
}

export const ApplicantTypePage: React.FunctionComponent<ATPProps> = ({
  handleSelect,
  touched,
  errors,
  isLoading,
  isRobot,
  values
}): React.ReactElement => {
  const isTouched = getIn(touched, 'applicantType');
  const error = getIn(errors, 'applicantType');
  return (
    <>
      <PageHeader subHeader="Which type of investor are you?" />
      <div className={styles.inputFormColumn}>
        <div className={styles.whySafari}>
          <div className={styles.inputField}>
            <Selectable
              analyticsTag="application-professional-investor"
              id="applicantTypeProUser"
              name="applicantType"
              onChange={(): void => {
                handleSelect(ApplicantTypes.pro);
              }}
              selectableType={SelectableTypes.RADIO}
              checked={values?.applicantType === ApplicantTypes.pro}
            >
              <div className={styles.selectableText}>
                <p>
                  <strong>I am a professional investor</strong>I have current/previous experience
                  working at buyside funds (hedge / mutual / private equity) or investment
                  institutions (family offices, asset managers, funds of funds, endowments, etc)
                </p>
              </div>
            </Selectable>
          </div>
        </div>
        <div className={styles.whySafari}>
          <div className={styles.inputField}>
            <Selectable
              analyticsTag="application-not-professional-investor"
              id="applicantTypeBasicUser"
              name="applicantType"
              onChange={(): void => {
                handleSelect(ApplicantTypes.basic);
              }}
              selectableType={SelectableTypes.RADIO}
              checked={values?.applicantType === ApplicantTypes.basic}
            >
              <div className={styles.selectableText}>
                <p>
                  <strong>I am not a buyside or professional investor</strong>For sellside
                  professionals, individual investors, FAs, wealth managers and other non-buyside
                  investors
                </p>
              </div>
            </Selectable>
          </div>
        </div>
        {isTouched && error && <div className={styles.fieldError}>{error}</div>}
      </div>
      <WizardSubmitButton
        submitText="Continue"
        analyticsTag="application-continue-applicant-type"
        isLoading={isLoading}
      />
      {isRobot && <RecaptchaFailed />}
      <PageFooter />
    </>
  );
};

export default ApplicantTypePage;
